exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* GEN 8 */\n#back-to-top {\n  cursor: pointer;\n  display: none;\n  opacity: 0;\n  position: fixed;\n  right: 0;\n  top: 35%;\n  z-index: 1; }\n  #back-to-top img {\n    height: auto;\n    max-width: 61px;\n    width: 100%; }\n", ""]);

